export default class ClientBadges {
    public general: string[];
    public predictor: string[];
    public topX: string[];
    public matchQuiz: string[];
}